<div class="loading-wrapper" *ngIf="isLoading">
  <i class="fas fa-circle-notch fa-spin"></i>
  <p>Loading...</p>
</div>